import {Image, ImageProps} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import {TestIdProps} from 'shared/web';

import {useThemeConfig} from '../../../hooks/useThemeConfig';

interface BadgeLogoProps extends TestIdProps, Omit<ImageProps, 'src'> {}

const DEFAULT_LOGO_PATH = '../../assets/images/logo.svg';
const ALT_TEXT = {
  DIGITAL_CERTIFICATE: 'Digital Certificate',
  COMPANY_LOGO: 'Company Logo',
};

export function BadgeLogo(props: BadgeLogoProps) {
  const {brandLogo, badgeLogo} = useThemeConfig();

  const hasCustomLogo = typeof brandLogo === 'string' || typeof badgeLogo === 'string';

  const logoSrc = match({brandLogo, badgeLogo})
    .with({badgeLogo: Pattern.string}, ({badgeLogo}) => badgeLogo)
    .with({brandLogo: Pattern.string}, ({brandLogo}) => brandLogo)
    .otherwise(() => DEFAULT_LOGO_PATH);

  const alt = hasCustomLogo ? ALT_TEXT.COMPANY_LOGO : ALT_TEXT.DIGITAL_CERTIFICATE;

  return (
    <Image
      alt={alt}
      isLazy
      width="auto"
      src={logoSrc}
      {...props}
      data-testid={props['data-testid']}
    />
  );
}
